import React from "react";
import { useSelector } from "react-redux";
import { totalAmount } from "../../../../../../../../../store/Concept/selectors";
import { SELECTED_ITEMS, TOTAL } from "./constants";
import { Wrapper, Container, ItemRight, ItemLeft } from "./styled";

const Footer = () => {
  const total = useSelector(totalAmount);
  const text = `${TOTAL}: $ ${total}`;

  return (
    <Wrapper>
      <Container>
        <ItemLeft>{SELECTED_ITEMS}</ItemLeft>
        <ItemRight>{text}</ItemRight>
      </Container>
    </Wrapper>
  );
};

export default Footer;
